<script>
import paymentMixin from "@/mixins/paymentMixin";

export default {
  mixins: [paymentMixin],

  props: {
    payment: {
      type: Object,
      required: true
    }
  }
};
</script>

<template>
  <section>
    <img src="/static/icon-credit-card.svg" height="50px">
    <div>
      <div class="mb-5 payment-method">
        <div>
          <b>Forma de pagamento:</b> Cartão de crédito
        </div>
        <div class="status" v-html="$options.filters.getPaymentLabel(payment.status)"></div>
      </div>

      <div>{{payment.funding_instrument | showCreditCardNumber}}</div>
    </div>
  </section>
</template>

<style scoped>
section {
  display: flex;
  flex-direction: row;
  align-items: center;
}

img {
  margin-right: 10px;
}

.payment-method {
  display: flex;
}

.status {
  margin-left: 10px;
}

@media (max-width: 768px) {
  section {
    flex-direction: column;
    text-align: center;
  }

  .payment-method {
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
  }

  .status {
    margin-left: 0;
    margin-top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/PaymentHistory/CreditCard.vue